import React from 'react';
import { IoMdMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { BiSolidMap } from "react-icons/bi"; 
import './Header.css';

const Header = () => {
  return (
    <div className="top-bar">
      <div className="container d-flex justify-content-between flex-wrap">
        <div className="left-info d-flex gap-4">
          <div className="info-item d-flex align-items-center">
            <FaPhoneAlt className="icon" />
            <a href="tel:+919540039182" style={{ color: 'white', textDecoration: 'none' }}>
  +91 9540039182
</a>
          </div>
          <div className="info-item d-flex align-items-center">
  <IoMdMail className="icon" />
  <a 
    href="mailto:info@loanonsalary.com" 
    style={{ color: "white", textDecoration: "none" }}
  >
    info@loanonsalary.com
  </a>
</div>
        </div>

        <div className="right-info info-item d-flex align-items-center">
  <BiSolidMap className="icon" />
  <span>Office no. 304, Laxman Palace, Delhi</span>
</div>


      </div>
    </div>
  );
};

export default Header;
